import __base_store from '@/store/__base_store'

/**
 * Store de apertura de caja (modelo `apertura_caja`).
 * Construido desde el factory común.
 */
export default __base_store({
	/** Estado propio del modelo. */
	state: {
		model_name: 'apertura_caja',
	},
})

